export { DeferredPaymentTemplate } from './DeferredPaymentTemplate';
export type {
  DeferredPaymentTemplateLabels,
  DeferredPaymentTemplateProps,
} from './DeferredPaymentTemplate.types';
